<template>
  <div>
    <el-select
      ref="select"
      :value="value"
      :placeholder="placeholder"
      :size="size"
      :filterable="filterable"
      :allow-create="allowCreate"
      :clearable="clearable"
      :disabled="disabled"
      :multiple="multiple"
      @change="change"
      :style="vstyle"
      :class="vclass"
    >
      <el-option
        v-for="(item, index) in optionData"
        :key="index"
        :label="item.label"
        :value="item.value"
      />

      <template #empty>
        <slot name="empty"></slot>
      </template>
    </el-select>
  </div>
</template>

<script>
import { request } from '@/api/service'

export default {
  name: 'cost-sector-select',
  props: {
    value: { type: [String, Array], require: true },
    custCode: { type: String, require: true },
    size: String,
    placeholder: { type: String, default: 'Please select' },
    disabled: { type: Boolean, default: false },
    allowCreate: { type: Boolean, default: false },
    filterable: { type: Boolean, default: false },
    clearable: { type: Boolean, default: true },
    multiple: { type: Boolean, default: false },
    label: [String, Array],
    labelJoin: { type: Boolean, default: false },
    labelSeparator: { type: String, default: '/' },
    options: {
      type: Object,
      default: () => ({ value: 'depCode', label: 'orgDepFullName' }),
    },
    vstyle: { type: String, default: 'width:100%;' },
    vclass: { type: String, default: '' },
  },
  data() {
    return { optionData: [], loaded: false }
  },
  computed: {
    optionsMap() {
      return Object.fromEntries(this.optionData.map((o) => [o.value, o]))
    },
  },
  watch: {
    custCode() {
      this.init()
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.loaded = false
      const data = await this.getData()
      this.optionData = this._dataTransform(data)
      this.loaded = true

      this.$emit('loaded', this.optionData)
    },
    async getData() {
      if (!this.custCode) return []

      const res = await request({
        url: '/digitalCenter/master/customer/cost/sector/select',
        method: 'POST',
        data: { custCode: this.custCode },
      }).catch(() => null)

      return res?.body?.data || []
    },
    _dataTransform(data) {
      if (!data?.length || !this.options) return []

      const { value, label } = this.options

      return data.map((t) => {
        return {
          value: value === 'this' ? { ...t } : t[value],
          label: t[label],
          option: { ...t },
        }
      })
    },
    change(val) {
      this.$emit('input', val)
      this.$emit('update:value', val)

      let label
      if (this.multiple) {
        const labels = !val?.length
          ? []
          : val.map((item) => this.optionsMap[item].label).filter(Boolean)
        label = this.labelJoin ? labels.join(this.labelSeparator || '') : labels
      } else {
        label = this.optionsMap[val]?.label || ''
      }

      const options = this.multiple
        ? !val?.length
          ? []
          : val.map((item) => this.optionsMap[item]?.option).filter(Boolean) ||
            []
        : this.optionsMap[val]?.option || {}

      this.$emit('update:label', label)
      this.$emit('change', val, { value: val, label }, options)
    },
    getOptions() {
      return new Promise((resolve) => {
        let task
        const get = () => {
          if (!this.loaded) {
            task = setTimeout(() => get(), 1000)
          } else {
            clearTimeout(task)

            setTimeout(() => {
              resolve(this.optionData)
            }, 0)
          }
        }
        get()
      })
    },
  },
}
</script>
